module.exports = __webpack_public_path__ + "static/media/classicos_masculino_sapatos.10cc5747.jpg";